import { ChartData } from "../../dataset-window/models/types";
import { PlotDataEx } from "../interfaces";

export const configBoxPlotData = (data: ChartData[], selectedColorPalette: Array<string>) => {
  return createPlotDataArr(data, selectedColorPalette);
};

const createPlotData = (d: ChartData, colorHex: string): PlotDataEx => {
  return {
    name: d.title,
    type: "box",
    //  unit: d.unit,
    showlegend: true,
    //  hovertemplate: `HOVER at %{x} <extra></extra>`,
    hoverinfo: "x",
    x: d.valueArr,
    opacity: 0.7,
    marker: {
      color: colorHex,
    },
  } as PlotDataEx;
};

const createPlotDataArr = (
  data: Array<ChartData>,
  selectedColorPalette: Array<string>
): Array<PlotDataEx> => {
  return data.map((d: ChartData, index: number) => {
    return createPlotData(d, selectedColorPalette[index]);
  });
};
